/* Kick Frame — verwachte leverdatum boven de "Add to cart"-knop.
   Rekent met de echte belofte "2-4 business days" (werkdagen, Nederlandse tijd):
   besteld op een werkdag telt vandaag als start, in het weekend telt maandag. */
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  // maatwerk (eigen ontwerp, kinderposter) kan langer duren: daar geen datum beloven;
  // de cadeaubon wordt per e-mail verstuurd, dus ook daar geen leverdatum
  if (/\/products\/(eigen-ontwerp|kids-football-poster|gift-card)/.test(location.pathname)) return;
  var button = form.querySelector('button[type="submit"]');
  if (!button) return;

  // datum van vandaag in Amsterdam, als UTC-middag zodat optellen nooit over DST struikelt
  var parts = {};
  try {
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
  } catch (e) { return; }
  var day = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12));

  function isWeekend(d) { var w = d.getUTCDay(); return w === 0 || w === 6; }
  function next(d) { return new Date(d.getTime() + 864e5); }
  function addBusinessDays(d, n) { while (n > 0) { d = next(d); if (!isWeekend(d)) n--; } return d; }

  while (isWeekend(day)) day = next(day);
  var from = addBusinessDays(day, 2), to = addBusinessDays(day, 4);

  // seizoensregel: alleen als ook de LAATSTE verwachte dag nog vóór het feest valt
  // (Sinterklaas: uiterlijk 4 dec in huis, kerst: uiterlijk 23 dec), vanaf 1 november
  var nl = /^nl/i.test(document.documentElement.lang || '');
  var y = +parts.year, season = '';
  var md = function (m, d) { return Date.UTC(y, m - 1, d, 12); };
  if (Date.UTC(y, +parts.month - 1, +parts.day, 12) >= md(11, 1)) {
    if (to.getTime() <= md(12, 4)) season = nl ? '🎁 Naar verwachting op tijd voor Sinterklaas' : '🎁 Expected before Sinterklaas (5 Dec)';
    else if (to.getTime() <= md(12, 23)) season = nl ? '🎄 Naar verwachting op tijd voor kerst' : '🎄 Expected before Christmas';
  }

  var fmt = function (d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  };

  var style = document.createElement('style');
  style.textContent = ''
    + '.kf-eta{display:flex;align-items:center;gap:.6rem;margin:0 0 .85rem;padding:.7rem .9rem;border:1px solid var(--grey-200,rgba(255,255,255,.12));'
    + 'border-radius:10px;font-size:.9rem;line-height:1.35;color:var(--ink,#fff);background:rgba(255,255,255,.03)}'
    + '.kf-eta svg{flex:none;width:22px;height:22px;color:var(--green,#2f8f5b)}'
    + '.kf-eta strong{font-weight:600}'
    + '.kf-eta small{display:block;opacity:.7;font-size:.78rem}'
    + '.kf-eta .kf-eta-season{display:block;margin-top:.3rem;font-weight:600;color:var(--gold,#d8b25a)}';
  document.head.appendChild(style);

  var eta = document.createElement('p');
  eta.className = 'kf-eta';
  eta.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>'
    + '<span>Order today, <strong>delivered ' + fmt(from) + ' – ' + fmt(to) + '</strong>'
    + '<small>Free shipping · estimated, 2–4 business days</small>'
    + (season ? '<span class="kf-eta-season">' + season + '</span>' : '') + '</span>';
  button.parentNode.insertBefore(eta, button);
})();
